import React, { useState } from 'react';

import { defineMessages, useIntl } from 'react-intl-next';

import { IconButton } from '@atlaskit/button/new';
import ShowMoreHorizontalIcon from '@atlaskit/icon/core/show-more-horizontal';
import Popup from '@atlaskit/popup';
import Tooltip from '@atlaskit/tooltip';

import { AudioFeatureMenuGroup, type AudioFeatureMenuItem } from './AudioFeatureMenuGroup';

const messages = defineMessages({
	moreOptionsLabel: {
		id: 'ai-audio.audio-player.overflow-menu.more-options-label',
		defaultMessage: 'More options',
		description: 'Label for the more options button in the overflow menu',
	},
});

type OverflowMenuProps = {
	items: AudioFeatureMenuItem[];
};

export const OverflowMenu = ({ items }: OverflowMenuProps) => {
	const [isOpen, setIsOpen] = useState(false);
	const { formatMessage } = useIntl();
	return (
		<Popup
			shouldRenderToParent
			isOpen={isOpen}
			testId="audio-player-overflow-menu"
			onClose={() => setIsOpen(false)}
			placement="bottom-start"
			content={() => <AudioFeatureMenuGroup items={items} />}
			trigger={(triggerProps) => (
				<Tooltip
					position="bottom"
					canAppear={() => !isOpen}
					content={formatMessage(messages.moreOptionsLabel)}
				>
					<IconButton
						{...triggerProps}
						isSelected={isOpen}
						appearance="subtle"
						spacing="compact"
						onClick={() => setIsOpen(!isOpen)}
						icon={ShowMoreHorizontalIcon}
						label={formatMessage(messages.moreOptionsLabel)}
					/>
				</Tooltip>
			)}
		/>
	);
};
